var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Overlay',{staticClass:"ae-modal",on:{"click":function($event){return _vm.$emit('close')}}},[_c('ModalPlain',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }